import React, { FC } from "react";
import {
  Card,
  CardContent,
  Typography,

  Box,
} from "@mui/material";
import Link from "next/link";
import RightSideArrow from "@/components/icons/RightSideArrow";
import { useTranslations } from "next-intl";

interface VacationsCardProps {
  data: {
    id: number;
    image: string;
    category: string;
    title: string;
    description: string;
  }[];
}

const VacationsCard: FC<VacationsCardProps> = ({
  data
}) => {

const t = useTranslations("");
  return (
    <div className="flex max-w-[1328px] mx-auto w-full justify-between items-center relative flex-wrap max-c-lg:space-y-6 px-4">
      {data.map((card ) => (
        <Card
          key={card.id}
          sx={{
            width: 412,
            height: 526,
            display: "flex",
            flexDirection: "column",
            borderRadius: "10px",
            border: `1px solid ${card.id %2 === 0 ? "#436b7b33" : "#bc9a20"}`,
            boxShadow: "0px 0px 35px #ff585012",
            overflow: "hidden",
            padding: 0,
          }}
      
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              padding: 0,
              gap: 2,
              alignItems: "start",
              flexGrow: 1,
            }}
           
          >
            <Box
              component="img"
              src={card.image}
              alt="Card Image"
              sx={{
                height: 248,
                width: "100%",
                objectFit: "cover",
              }}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
               className="!px-4 c-lg:w-[372px] w-full"
            >
              <Typography variant="subtitle2" fontWeight={600}>
                {card.category}
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                {card.title}
              </Typography>
              <Typography className="!text-primary text-wrap" variant="body1">
                {card.description}
              </Typography>
            </Box>
            <Link
              href="#"
              className="inline-flex mx-4 items-center gap-2 text-start mt-auto text-secondary font-bold text-sm ">
              {t(`Learn More`)} <RightSideArrow  className="rtl:rotate-180"/>
            </Link>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default VacationsCard;
